export const DOCUMENT_DATA_GRID_CODES = {
  BUSINESS_CASE: 'document-context-list-business-case',
  CHECKOUT: 'document-context-list-business-case-checkout',
} as const;
